import { assign } from '../common/utils';

const initialState = {
    brandId: null,
    newUser: null
}

const movieList = (state = initialState, action) => {
    switch (action.type) {
        case 'brandId':
            return assign({},state,{brandId:action.brandId});
        case 'newUser':
            return assign({},state,{newUser:action.newUser});
        case 'brandId_change':
            return assign(state, {
                brandId: action.brandId
            });
        case 'newUser_change':
            return assign(state, {
                newUser: action.newUser
            });
        
        default:
            return state;
    }
};

export default movieList;